import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig/firebase";

/**
 * Obtiene todos los materiales disponibles.
 * @returns {Promise<Array>} - Array con todos los materiales.
 */
export async function obtenerMaterialesPorNivel() {
  const materialesRef = collection(db, "recursos");
  const allSnapshot = await getDocs(materialesRef);
  const materiales = allSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));


  return materiales;
}

// Función de prueba para usar en un efecto
export async function testObtenerMaterialesPorNivel() {
  await obtenerMaterialesPorNivel();
} 